// quick-add-cart-sync.js
(function() {
  function updateQuickAddButtons() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const variantIdsInCart = new Set(
          cart.items.map(item => item.variant_id.toString())
        );
        
        document.querySelectorAll('.quick-add__submit[data-variant-id]').forEach(button => {
          const variantId = button.getAttribute('data-variant-id');
          if (variantIdsInCart.has(variantId)) {
            button.classList.add('quick-added__submit');
          } else {
            button.classList.remove('quick-added__submit');
          }
        });
      })
      .catch(err => console.warn('Failed to update quick-add buttons:', err));
  }

  // Wait for subscribe function to be available (Dawn loads it asynchronously)
  function init() {
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // Subscribe to Dawn's native cart update event
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        // Optional: log for debugging
        console.log('Cart updated via Dawn pub/sub', event);
        updateQuickAddButtons();
      });
      // Also run once on page load
      updateQuickAddButtons();
    } else {
      // If subscribe isn't ready yet, wait a bit and try again
      setTimeout(init, 100);
    }
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();